import { SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, Input, message, Popconfirm, Row, Space, Table, Tooltip, Pagination } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as ArchiveRestore } from "../../Images/ArchiveRestore.svg";
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import dayjs from 'dayjs';

import { fetchArchiveBlosterList, unArchiveBloster } from '../../slices/bolster';

function ArchiveBloster() {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pagesize, setPageSize] = useState(10);
    const [orderBy, setOrderBy] = useState('');

    const dispatch = useDispatch();
    const { data = [], totalRecord = 0, status, } = useSelector(state => state.bloster || {});
    useEffect(() => {
        dispatch(
            fetchArchiveBlosterList({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }),
        );
    }, [dispatch, page, pagesize, search, orderBy]);

    const handleSearch = e => {
        setSearch(e.target.value);
        setPage(1); // Reset to the first page when searching
    };

    const resetFilter = () => {
        setSearch('');
        setPage(1);
        setOrderBy('');
    };

    const handlePageChange = newPage => {
        setPage(newPage);
    };

    const handlePageSizeChange = (current, size) => {
        setPage(1);
        setPageSize(size);
    };

    const GetSortingEnumValue = (sortField, sortOrder) => {
        let sortingEnumKey = 'id';

        if (sortField === 'bloster_no' && sortOrder === 'ascend') {
            sortingEnumKey = 'bloster_no';
        }
        if (sortField === 'bloster_no' && sortOrder === 'descend') {
            sortingEnumKey = '-bloster_no';
        }
        if (sortField === 'related_dies' && sortOrder === 'ascend') {
            sortingEnumKey = 'related_dies';
        }
        if (sortField === 'related_dies' && sortOrder === 'descend') {
            sortingEnumKey = '-related_dies';
        }

        if (sortField === 'bloster_image' && sortOrder === 'ascend') {
            sortingEnumKey = 'bloster_image';
        }
        if (sortField === 'bloster_image' && sortOrder === 'descend') {
            sortingEnumKey = '-bloster_image';
        }

        if (sortField === 'press' && sortOrder === 'ascend') {
            sortingEnumKey = 'press';
        }
        if (sortField === 'press' && sortOrder === 'descend') {
            sortingEnumKey = '-press';
        }
        if (sortField === 'autocard' && sortOrder === 'ascend') {
            sortingEnumKey = 'autocard';
        }
        if (sortField === 'autocard' && sortOrder === 'descend') {
            sortingEnumKey = '-autocard';
        }

        if (sortField === 'pdf' && sortOrder === 'ascend') {
            sortingEnumKey = 'pdf';
        }
        if (sortField === 'pdf' && sortOrder === 'descend') {
            sortingEnumKey = '-pdf';
        }
        if (sortField === 'created_by__first_name' && sortOrder === 'ascend') {
            sortingEnumKey = 'created_by__first_name';
        }
        if (sortField === 'created_by__first_name' && sortOrder === 'descend') {
            sortingEnumKey = '-created_by__first_name';
        }

        if (sortField === 'created_by__last_name' && sortOrder === 'ascend') {
            sortingEnumKey = 'created_by__last_name';
        }
        if (sortField === 'created_by__last_name' && sortOrder === 'descend') {
            sortingEnumKey = '-created_by__last_name';
        }
        if (sortField === 'updated_by__first_name' && sortOrder === 'ascend') {
            sortingEnumKey = 'updated_by__first_name';
        }
        if (sortField === 'updated_by__first_name' && sortOrder === 'descend') {
            sortingEnumKey = '-updated_by__first_name';
        }
        if (sortField === 'updated_by__last_name' && sortOrder === 'ascend') {
            sortingEnumKey = 'updated_by__last_name';
        }
        if (sortField === 'updated_by__last_name' && sortOrder === 'descend') {
            sortingEnumKey = '-updated_by__last_name';
        }
        return sortingEnumKey;
    };
    const handleTableChange = async (pagination, filters, sorter, ordering) => {
        if (sorter && sorter.columnKey && sorter.order) {
            const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
            setOrderBy(orderBy);
        }
        setPageSize(pagination.pageSize);
    };
    const dataSource = data.map((item, index) => ({
        ...item,
        key: item.id || index,
        SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
    }));

    const handleRestore = id => {
        if (!id) {
            message.error('Missing ID for deletion!');
            return;
        }

        dispatch(unArchiveBloster(id)).unwrap()
            .then(() => {
                message.success('Bolster Unarchived Successfully!');
                dispatch(
                    fetchArchiveBlosterList({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }),
                );

            })
            .catch(error => {
                if (typeof error === 'object' && error !== null) {
                    const messages = [];
                    for (const key in error) {
                        if (Array.isArray(error[key])) {
                            messages.push(`${key}: ${error[key].join(', ')}`);
                        }
                    }

                    if (messages.length > 0) {
                        message.error(messages.join('; '));
                    } else {
                        message.error('An unknown error occurred.');
                    }
                } else if (typeof error === 'string') {
                    message.error(error); // Handle string error
                } else if (error instanceof Error) {
                    message.error(error.message); // Handle Error object
                } else {
                    message.error('An unknown error occurred.');
                }
            });
    };
    const columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'SrNo',
            key: 'SrNo',
        },
        {
            title: 'Bolster No.',
            dataIndex: 'bloster_no',
            key: 'bloster_no',
            sorter: true,
        },
        {
            title: 'Bolster Image',
            dataIndex: 'bloster_image',
            key: 'bloster_image',
            render: (record) => {
                const fileUrl = record;
                if (!fileUrl) return <span>N/A</span>;

                const fileExtension = fileUrl.split('.').pop().toLowerCase();

                if (fileExtension === 'pdf') {
                    return (
                        <Button
                            type="link"
                            style={{ padding: '0px' }}
                            onClick={async () => {
                                try {
                                    const response = await fetch(fileUrl);

                                    if (!response.ok) {
                                        throw new Error(`HTTP error! Status: ${response.status}`);
                                    }

                                    const blobData = await response.blob();
                                    const blob = new Blob([blobData], { type: 'application/pdf' });
                                    const blobURL = URL.createObjectURL(blob);
                                    window.open(blobURL);
                                } catch (error) {
                                    console.error('Failed to fetch the PDF:', error);
                                    message.error('Failed to open the PDF. Please try again.');
                                }
                            }}
                        >
                            View PDF
                        </Button>
                    );
                } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)) {
                    return <img width="55" height="55" src={fileUrl} alt="Die Diagram" />;
                } else {
                    return <span>Unsupported file type</span>;
                }
            },
        },
        {
            title: 'Suitable Dies',
            dataIndex: 'related_dies',
            key: 'related_dies',
            sorter: true,
            render: (related_dies) => {
                if (related_dies && related_dies.length > 0) {
                    return related_dies.map((die) => die.die_number).join(', ');
                }
                return <span>N/A</span>;
            },
        },
        {
            title: 'Press',
            dataIndex: 'press',
            key: 'press',
            render: (value) => {
                return value ? value.name : <span>N/A</span>;
            },
            sorter: true,
        },
        {
            title: 'Bolster Autocad',
            dataIndex: 'autocard',
            key: 'autocard',
            sorter: true,
            render: (record) => {
                const fileUrl = record;

                if (!fileUrl) return <span>N/A</span>; // Display N/A if no file URL is available

                const fileExtension = fileUrl.split('.').pop().toLowerCase();

                if (fileExtension === 'pdf') {
                    return (
                        <Button
                            type="link"
                            style={{ padding: '0px' }}
                            onClick={async () => {
                                try {
                                    const response = await fetch(fileUrl);

                                    if (!response.ok) {
                                        throw new Error(`HTTP error! Status: ${response.status}`);
                                    }

                                    const blobData = await response.blob();
                                    const blob = new Blob([blobData], { type: 'application/pdf' });
                                    const blobURL = URL.createObjectURL(blob);
                                    window.open(blobURL);
                                } catch (error) {
                                    console.error('Failed to fetch the PDF:', error);
                                    message.error('Failed to open the PDF. Please try again.');
                                }
                            }}
                        >
                            View PDF
                        </Button>
                    );
                } else if (fileExtension === 'dwg') {
                    return (
                        <Button
                            type="link"
                            style={{ padding: '0px' }}
                            onClick={() => {
                                window.open(fileUrl, '_blank');
                            }}
                        >
                            View AutoCAD
                        </Button>
                    );
                } else {
                    return <span>N/A</span>; // Display N/A for unsupported file types
                }
            },
        },

        {
            title: 'Bolster PDF',
            dataIndex: 'pdf',
            key: 'pdf',
            render: (record) => {
                const fileUrl = record;
                if (!fileUrl) return <span>N/A</span>;
                const fileExtension = fileUrl.split('.').pop().toLowerCase();
                if (fileExtension === 'pdf') {
                    return (
                        <Button type="link" style={{ padding: '0px' }} onClick={async () => {
                            const response = await fetch(fileUrl);
                            if (!response.ok) {
                                throw new Error(`HTTP error! Status: ${response.status}`);
                            }

                            const blobData = await response.blob();
                            var blob = new Blob([blobData], { type: 'application/pdf' });
                            var blobURL = URL.createObjectURL(blob);
                            window.open(blobURL);

                        }}>View PDF</Button>
                    );
                } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)) {
                    return <img width="55" height="55" src={fileUrl} alt="Die Diagram" />;
                } else {
                    return <span>Unsupported file type</span>;
                }
            }
        },
        {
            title: 'Archive At',
            dataIndex: 'archive_at',
            key: 'archive_at',
            sorter: true,
            render: (record) => {
                return (
                    <span>{record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'} </span>
                )
            }
        },
        {
            title: 'Archive By',
            dataIndex: 'updated_by',
            key: 'updated_by',
            sorter: true,
            render: (record) => {
                return (
                    <span>{record ? `${record.first_name} ${record.last_name}` : 'N/A'}</span>
                )
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (_, record) => (
                <Space>
                    <Tooltip placement="top" title="Restore">
                        <Popconfirm
                            title="Are you sure you want to Unarchive this record?"
                            onConfirm={() => handleRestore(record.id)} // Trigger delete on confirmation
                            onCancel={() => message.info('Action cancelled')} // Optional cancel action
                            okText="Yes"
                            cancelText="No"
                        >
                            <ArchiveRestore className="ArchiverestorImg" />
                        </Popconfirm>
                    </Tooltip>
                </Space>
            ),
        },
    ];


    const rowSelection = {
        selectedRowKeys,
        onChange: selectedKeys => {
            setSelectedRowKeys(selectedKeys);
        },
    };

    return (
        <>
            <div className='sticyaction'>
                <Row className="pagenamerow" justify="space-between" align="middle">
                    <Col>
                        <h2>Archived Bolsters</h2>
                        <div className="bredcrumbwrp">
                            <Link to="/bolster-list" className="back">
                                <Back /> BACK
                            </Link>
                            <Breadcrumb
                                items={[
                                    { title: <Link to="/bolster-list">Bolsters</Link> },
                                    { title: 'Archived Bolsters' }
                                ]}
                            />
                        </div>
                    </Col>
                    <Col>
                        <Space size="middle">
                            <Input
                                placeholder="Search"
                                className='searchbox'
                                prefix={<SearchOutlined />}
                                onChange={handleSearch}
                                style={{ width: 200 }}
                                value={search}
                            />
                            <Tooltip placement="top" title={'Reset Filter'}>
                                <Button type="primary" disabled={!search && !orderBy} className='iconlink' onClick={resetFilter}>
                                    <FilterIcon />
                                </Button>
                            </Tooltip>
                        </Space>
                    </Col>
                </Row>
            </div>
            <Row gutter={[16, 16]}>
            </Row>
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: 1, overflow: 'auto' }}>
                    <Table
                        //rowSelection={rowSelection}
                        rowKey="id"
                        dataSource={dataSource}
                        columns={columns}
                        loading={status === 'loading'}
                        pagination={false}
                        onChange={handleTableChange}
                        scroll={{
                            x: 1500,
                            y: 400,
                        }}
                    />
                </div>

                <div
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        zIndex: 1000,
                        background: '#fff',
                        padding: 10,
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    <Pagination
                        current={page}
                        pageSize={pagesize}
                        total={totalRecord}
                        showSizeChanger
                        onShowSizeChange={handlePageSizeChange}
                        pageSizeOptions={["20", "50", "100"]}
                        showTotal={total => `Total ${total} items`}
                        onChange={handlePageChange}
                        locale={{ items_per_page: 'Items / Page' }}
                    />
                </div>
            </div>
        </>
    )
}

export default ArchiveBloster
